import * as React from "react";
import { EmployeeDto } from "Api/Api";
import styled from "styled-components";
import { useResource, Resources } from "Translations/Resources";
import { Typography } from "@material-ui/core";
import { formatDate } from "Utils/DateUtils";
import { isEmptyArray } from "Utils/ArrayUtils";

type Props = {
  employee: EmployeeDto;
};

const StyledWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

const StyledLabel = styled.div`
  font-size: ${props => props.theme.typography.h5.fontSize}px;
  font-weight: 500;
  color: ${props => props.theme.palette.text.secondary};
  margin: ${props => props.theme.spacing(1.25, 0, 0.5, 0)};
`;

const StyledPositions = styled.div`
  display: grid;
  grid-template-columns: auto auto auto;
  gap: ${props => props.theme.spacing(1, 0.625)};
  justify-content: flex-start;
`;

export const EmployeeDetailDepartments: React.FunctionComponent<Props> = props => {
  const { employee } = props;
  const { t } = useResource();

  return (
    <>
      {!isEmptyArray(employee.departments) && (
        <>
          <StyledWrapper className={"row"}>
            <div className={"row-title"}>
              {t(Resources.HumanResources.Employees.Detail.Departments.Title)}
            </div>
            <div>
              <div>
                {employee.departments
                  .map(department => department.departmentName)
                  .join(", ")}
              </div>
              {!isEmptyArray(employee.departmentChanges) && (
                <>
                  <StyledLabel>
                    {t(
                      Resources.HumanResources.Employees.Detail.Departments
                        .History,
                    )}
                  </StyledLabel>
                  <StyledPositions>
                    {employee.departmentChanges?.map(department => (
                      <React.Fragment
                        key={department.employeeDepartmentChangeID}
                      >
                        <Typography align={"right"}>
                          {formatDate(department.dateChanged)}
                        </Typography>
                        <Typography>-</Typography>
                        <Typography>{department.departmentName}</Typography>
                      </React.Fragment>
                    ))}
                  </StyledPositions>
                </>
              )}
            </div>
          </StyledWrapper>
          <hr />
        </>
      )}
    </>
  );
};
